import React from "react"
import { Compass } from "lucide-react"
import { Link } from "../router"
import { Card, EmptyState } from "../ui"

export function NotFoundPage() {
  return <div className="page"><Card><EmptyState icon={Compass} title="Page not found" copy="That page is not part of this team workspace." action={<Link className="button button--primary" to="/">Back to overview</Link>} /></Card></div>
}
